import React, { Component } from "react";

import { MobileValidation } from "components/tools";
import { MCheckbox } from "components/forms";
import {
  BoxDanger,
  MnemoLoading,
  ModalHandler,
  PDFView,
  SupportoTecnico,
} from "components/misc";
import { networkErrorHelper, enrollmentService } from "libs";
import { Button } from "design-react-kit";

export class EnrollSignForm extends Component {
  state = {
    documentError: false,
    documentLoad: true,
    loading: true,
    confirmedMobile: false,
    accept: true,
    accept_service: true,
    alertMessages: [],
  };

  componentDidMount() {
    this.loadDocument(this.props.enrollData.enrollment.id);
  }

  loadDocument(enrollmentId) {
    enrollmentService
      .prepareSign(enrollmentId)
      .then(({ data }) => {
        const { userEnrollmentFile } = data.payload;
        //update after 3 seconds: because the document in S3 isn't istantly available
        setTimeout(() => {
          this.setState({
            loading: false,
            loadingError: false,
            userEnrollmentFile,
          });
        }, 3000);
      })
      .catch((errors) => {
        console.log(errors);
        networkErrorHelper.notify(errors);
        this.setState({ loading: false, loadingError: true });
      });
  }

  validate() {
    const { accept, accept_service, confirmedMobile } = this.state;
    let alertMessages = [];

    if (!accept_service) {
      alertMessages.push(
        "è necessario prestare il  consenso all'utilizzo del servizio di Firma Elettronica Avanzata"
      );
    }
    if (!accept) {
      alertMessages.push(
        "è necessario acconsente a sottoscrivere il documento"
      );
    }
    if (!confirmedMobile) {
      alertMessages.push(
        'è necessario premere il tasto "Invia codice", inserire il codice ricevuto via SMS e premere il tasto "Conferma codice"'
      );
    }

    this.setState({ alertMessages });

    let isValid = accept && accept_service && confirmedMobile;
    return isValid;
  }

  onChangeAccept = (_, value) => {
    this.setState({ accept: value });
  };

  onChangeAccept_service = (_, value) => {
    this.setState({ accept_service: value });
  };

  textFEA() {
    return (
      <>
        <h2>
          Condizioni di utilizzo del Servizio di Firma Elettronica Avanzata
          (FEA)
        </h2>
        <p>
          Per la sottoscrizione della documentazione, Mnemosine mette a
          disposizione un servizio di
          <strong>Firma Elettronica Avanzata</strong> (di seguito, il{" "}
          <strong>Servizio</strong>), conforme al{" "}
          <strong>Codice dell'Amministrazione Digitale</strong> (D.Lgs. 82/2005
          e s.m.i.) e al <strong>Regolamento (UE) n. 910/2014 (eIDAS)</strong>.
        </p>

        <h3>Informazioni preliminari</h3>
        <ul>
          <li>
            Prestando il consenso all'utilizzo del Servizio, l'Utente accetta di
            sottoscrivere la domanda di iscrizione mediante FEA tramite
            l'inserimento di un codice di sblocco
            <em>One-Time Password</em> (<strong>OTP</strong>) inviato via SMS al
            numero di cellulare verificato in fase di registrazione.
          </li>
          <li>
            La connessione univoca tra Utente e firma, nonché il controllo
            esclusivo del sistema di generazione della firma, sono assicurati
            dall'uso dell'OTP e dalle ulteriori misure tecniche e organizzative
            del Servizio (identificazione, tracciatura e marcatura temporale).
          </li>
          <li>
            A sottoscrizione avvenuta, all'indirizzo e-mail indicato dall'Utente
            sarà inviato un file in formato PDF contenente il documento
            sottoscritto e le relative evidenze tecniche (hash e riferimento
            temporale).
          </li>
          <li>
            Le modalità di firma così adottate producono gli effetti di cui
            all'art. 2702 c.c., fatti salvi i casi in cui la legge richieda
            forme particolari.
          </li>
          <li>
            Le caratteristiche tecniche essenziali del Servizio sono riportate
            di seguito; la documentazione tecnica di dettaglio è disponibile su
            richiesta.
          </li>
          <li>
            In caso di smarrimento della documentazione, l'Utente potrà
            richiederne copia a Mnemosine.
          </li>
          <li>
            L'Utente può revocare in qualsiasi momento il consenso all'utilizzo
            del Servizio compilando l'apposita modulistica.
          </li>
          <li>
            Mnemosine adotta misure tecniche e organizzative adeguate per
            proteggere i dati personali e i dati di firma dell'Utente. Per
            maggiori informazioni consultare l'Informativa Privacy.
          </li>
        </ul>

        <p>
          Ai sensi del CAD (D.Lgs. 82/2005 e s.m.i.), un documento informatico
          sottoscritto con FEA che rispetti i requisiti normativi produce gli
          effetti previsti dall'art. 2702 c.c. (efficacia della scrittura
          privata).
        </p>

        <h3>Caratteristiche tecniche del Servizio</h3>
        <p>
          La FEA consente la sottoscrizione digitale di documenti da smartphone,
          tablet o PC senza necessità di stampa. Il Servizio opera nel rispetto
          delle norme vigenti e prevede:
        </p>
        <ul>
          <li>
            <strong>Identificazione</strong> dell'Utente mediante acquisizione e
            verifica di un documento d'identità in corso di validità e degli
            ulteriori dati richiesti.
          </li>
          <li>
            <strong>Controllo esclusivo</strong> della firma tramite OTP monouso
            inviato via SMS al numero di cellulare verificato.
          </li>
          <li>
            <strong>Connessione univoca</strong> della firma al documento
            tramite calcolo dell'impronta (hash) del file da sottoscrivere.
          </li>
          <li>
            <strong>Integrità e immodificabilità</strong> del documento
            sottoscritto tramite sigillo/timbro digitale del sistema e
            riferimento temporale (timestamp).
          </li>
          <li>
            <strong>Tracciatura</strong> del processo (audit log) con
            conservazione delle evidenze tecniche della sottoscrizione.
          </li>
        </ul>

        <p>Il processo di firma si articola come segue:</p>
        <ol>
          <li>
            L'Utente viene identificato caricando il documento d'identità e
            completando i passaggi richiesti.
          </li>
          <li>
            Il sistema genera l'hash del documento da sottoscrivere e invia
            all'Utente un OTP via SMS.
          </li>
          <li>
            L'Utente inserisce l'OTP e il sistema appone la firma avanzata,
            sigilla il documento e applica il riferimento temporale.
          </li>
          <li>
            Il documento firmato è reso disponibile in formato PDF e inviato via
            e-mail.
          </li>
        </ol>

        <h3>Informativa privacy</h3>
        <p>
          Il trattamento dei dati personali avviene ai sensi del Regolamento
          (UE) 2016/679 (GDPR) e del D.Lgs. 196/2003 e s.m.i. Per informazioni
          su titolare, finalità, basi giuridiche, tempi di conservazione,
          diritti dell'interessato e contatti del DPO, consultare l'Informativa
          Privacy disponibile sul sito.
        </p>
      </>
    );
  }

  showFEA = (e) => {
    e.stopPropagation();
    ModalHandler.show(
      null,
      "Firma Elettronica Avanzata",
      this.textFEA(),
      null,
      null,
      "Chiudi",
      null,
      true,
      false
    );
  };

  onConfirmed = () => {
    this.setState({ confirmedMobile: true });
  };

  onDocumentError = () => {
    this.setState({ documentError: true, documentLoad: false });
  };

  onGoToFill = () => {
    const { enrollment } = this.props.enrollData;

    this.setState({ loading: true });

    const payload = {
      ...enrollment,
      currentStep: "fill",
    };

    enrollmentService
      .updateEnrollment(payload)
      .then(() => {
        window.location.reload();
      })
      .catch((error) => {
        console.error(error);
        networkErrorHelper.notify(error);
        this.setState({ loading: false });
      });
  };

  render() {
    const { enrollment, validatorProps, user, userProfile, canEdit } =
      this.props.enrollData;

    const { alertMessages, loading, loadingError, userEnrollmentFile } =
      this.state;

    if (loading) return <MnemoLoading />;
    if (loadingError)
      return (
        <BoxDanger>
          Si è verificato un errore durante i caricamento del modulo,{" "}
          <SupportoTecnico />
        </BoxDanger>
      );

    const file = {
      url:
        process.env.REACT_APP_API_URL +
        "/enrollment/download/" +
        userEnrollmentFile.id,
    };

    return (
      <>
        <h5>Domanda di iscrizione</h5>
        <hr />
        <PDFView file={file.url} />
        {canEdit && (
          <>
            <h5>Conferma i tuoi dati</h5>
            <hr />
            <p>
              Continuando con la procedura confermi i dati inseriti nella
              domanda di iscrizione. Se hai riscontrato degli errori cliccare
              sul tasto "Modifica dati della domanda"
            </p>
            <div className="text-right">
              <Button
                color="primary bg-dark"
                tag="button"
                onClick={this.onGoToFill}
              >
                Modifica dati della domanda
              </Button>
            </div>
          </>
        )}
        <h5>Conferma la tua identità</h5>
        <hr />
        <MobileValidation
          {...validatorProps}
          onConfirmed={this.onConfirmed}
        ></MobileValidation>
        <h5>La tua firma include</h5>
        <hr />
        Nome firmatario:{" "}
        <b>
          {user.name} {user.surname}
        </b>
        <br />
        Codice fiscale: <b>{userProfile.fiscalCode}</b>
        <br />
        E-mail: <b>{user.email}</b>
        <br />
        Numero di cellulare: <b>{userProfile.mobile}</b>
        <br />
        Codice documento: <b>{enrollment.orderNumber}</b>
        <hr />
        <MCheckbox
          onChange={this.onChangeAccept_service}
          id="accept_service"
          name="accept_service"
          readOnly={false}
          value={true}
          disabled={false}
        >
          <p>
            Presto il mio consenso all'utilizzo del servizio di Firma
            Elettronica Avanzata e di accettare le
            <span className="text-green" onClick={(e) => this.showFEA(e)}>
              <b> condizioni del servizio</b>
            </span>
          </p>
        </MCheckbox>
        <MCheckbox
          onChange={this.onChangeAccept}
          id="accept"
          name="accept"
          readOnly={false}
          value={true}
          disabled={false}
        >
          <p>
            Cliccando su <b>Firma</b> acconsente a sottoscrivere in formato
            elettronico il documento identificato dal codice
            <b> {enrollment.orderNumber} </b>
          </p>
        </MCheckbox>
        {alertMessages.length > 0 && (
          <>
            <BoxDanger>
              <ul>
                {alertMessages.map((message, i) => (
                  <li key={i}>{message}</li>
                ))}
              </ul>
            </BoxDanger>
          </>
        )}
      </>
    );
  }
}
